import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { api } from "api";

export const useTermsAndConditions = (examId?: number) => {
  const { i18n } = useTranslation();

  const { data, isFetching } = useQuery({
    queryKey: ["terms"],
    enabled: !!examId,
    queryFn: () =>
      api.termsAndCondition.getTermsAndCondition({
        examDateId: examId,
      }),
    select: (response) => response.data,
  });

  const fileName = i18n.language === "en" ? data?.fileEn : data?.filePl;
  const rawContent = i18n.language === "en" ? data?.contentEn : data?.contentPl;

  return {
    isFetching,
    fileName,
    rawContent,
  };
};
